import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VShowSlide from '@/plugins/v-show-slide.esm.js'
import customHorizontalSliding from '@/plugins/customHorizontalSliding.js'
import i18n from './i18n'

createApp(App)
    .use(i18n)
    .use(store)
    .use(router)
    .use(VShowSlide)
    .use(customHorizontalSliding)
    .mount('#app')
